import { SET_LOGIN } from '../types/login.types';

// Keep this slice minimal: it stores just the user info payload
const loginReducer = (state = [], action) => {
  switch (action.type) {
    case SET_LOGIN:
      return action.payload;
    default:
      return state;
  }
};

export default loginReducer;
